//-----------------------------------------------------------------------------
//  Copyright (c) 2019 by Dell Inc.
//
// All rights reserved.  This software may not be copied, disclosed,
// transferred, or used except in accordance with a license granted
// by Dell Inc.  This software embodies proprietary information
// and trade secrets of Dell Inc.
//
//-----------------------------------------------------------------------------

import React from 'react';
import styled from '@emotion/styled';
import TableLoadingIcon from '../icons/TableLoadingIcon';

const Overlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  padding: 5px 15px;
  border-radius: 10px;
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 12.5rem;
  width: inherit;
  justify-content: center;
  align-items: center;
`;

export default function TableLoadingOverlay() {
  return (
    <Overlay>
      <LoadingContainer>
        <TableLoadingIcon testIdentifier="table-loading-icon" />
      </LoadingContainer>
    </Overlay>
  );
}
